<dynamic-form
  *ngIf="columns && columns?.length > 0"
  [apiName]="apiName"
  [label]="label"
  [group]="formGroup"
  [columns]="columns"
  (cancelChange)="cancel()"
  (submitChange)="save()">
</dynamic-form>
